export function toInt(data) {
  try {
    if (typeof data === 'number') {
      data = data + ''
    } else if (typeof data === 'string') {
      data = data.trim();
      if (data.length === 0) {
        data = '0'
      }
    } else {
      data = '0'
    }
    return parseInt(data)
  } catch (e) {
    return 0
  }
}



// WEBPACK FOOTER //
// ./src/tools/toInt.js